import { apiSlice } from './apiSlice';
import { STORETRANSFERS_URL } from '../constants';

export const storeTransfersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({

    // Create a new storeTransfer
    createStoreTransfer: builder.mutation({
      query: (storeTransfer) => ({
        url: STORETRANSFERS_URL,
        method: 'POST',
        body: storeTransfer,
      }),
      invalidatesTags: ['StoreTransfers'],
    }),

    // Get storeTransfer details by ID
    getStoreTransferDetails: builder.query({
      query: (id) => ({
        url: `${STORETRANSFERS_URL}/${id}`,
      }),
      keepUnusedDataFor: 5,
      providesTags: (result, error, id) => [{ type: 'StoreTransfer', id }],
    }),

    // Get logged-in user's storeTransfers
    getMyStoreTransfers: builder.query({
      query: () => ({
        url: `${STORETRANSFERS_URL}/mine`,
      }),
      keepUnusedDataFor: 5,
      providesTags: ['MyStoreTransfers'],
    }),

    // Get all storeTransfers (Admin)
    getStoreTransfers: builder.query({
      query: () => ({
        url: STORETRANSFERS_URL,
      }),
      keepUnusedDataFor: 5,
      providesTags: ['StoreTransfers'],
    }),

    // Mark storeTransfer as delivered
    deliverStoreTransfer: builder.mutation({
      query: (storeTransferId) => ({
        url: `${STORETRANSFERS_URL}/${storeTransferId}/deliver`,
        method: 'PUT',
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'StoreTransfer', id },
        'StoreTransfers',
      ],
    }),

    // Update storeTransfer (single correct version)
    updateStoreTransfer: builder.mutation({
      query: ({ storeTransferId, ...body }) => ({
        url: `${STORETRANSFERS_URL}/${storeTransferId}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'StoreTransfer', id },
        'StoreTransfers',
      ],
    }),

    // Upload multiple images for storeTransfers
    uploadStoreTransferImages: builder.mutation({
      query: (data) => ({
        url: `/api/upload`,
        method: 'POST',
        body: data, // must be FormData
      }),
    }),

    // Delete storeTransfer
    deleteStoreTransfer: builder.mutation({
      query: (storeTransferId) => ({
        url: `${STORETRANSFERS_URL}/${storeTransferId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['StoreTransfers'],
    }),
  }),
});

export const {
  useCreateStoreTransferMutation,
  useGetStoreTransferDetailsQuery,
  useGetMyStoreTransfersQuery,
  useGetStoreTransfersQuery,
  useDeliverStoreTransferMutation,
  useDeleteStoreTransferMutation,
  useUploadStoreTransferImagesMutation,
  useUpdateStoreTransferMutation,
} = storeTransfersApiSlice;
